import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { dateOptionsCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_INSIGHTS_FOOTFALL_OVER_TIME,
  FETCH_INSIGHTS_FOOTFALL_OVER_TIME_ERROR,
  SET_INSIGHTS_FOOTFALL_OVER_TIME,
} from '../../constants';

// Organisation insights - Footfall over time

// By day:
// 'https://api.intelligence.landmarksid.com/report/organisation-footfall-over-time?organisationId=5b457bae75cca00004a0c4c8&since=2018-10-15T00%3A53%3A00%2B05%3A00&until=2018-10-28T23%3A53%3A00%2B05%3A00&timeUnit=day&areas=Auckland,Hurunui%20District'

// By hour:
// 'https://api.intelligence.landmarksid.com/report/client-subcategory-footfall-over-time?customSubcategory=Grocery&since=2018-10-15T00%3A53%3A00%2B05%3A00&until=2018-10-28T23%3A53%3A00%2B05%3A00&timeUnit=hour&areas=Auckland,Hurunui%20District'

// Category insights - Footfall over time

// By day:
// 'https://api.intelligence.landmarksid.com/report/client-subcategory-footfall-over-time?customSubcategory=Grocery&since=2018-10-15T00%3A53%3A00%2B05%3A00&until=2018-10-28T23%3A53%3A00%2B05%3A00&timeUnit=day&areas=Auckland,Hurunui%20District'

// By hour:
// 'https://api.intelligence.landmarksid.com/report/client-subcategory-footfall-over-time?customSubcategory=Grocery&since=2018-10-15T00%3A53%3A00%2B05%3A00&until=2018-10-28T23%3A53%3A00%2B05%3A00&timeUnit=hour&areas=Auckland,Hurunui%20District'


function reportsCretiria(state$) {

  const hourAPIEndpoint =
    state$.value.insightsCriteria.insightType === 'organisation' &&
      state$.value.insightsCriteria.organisation.value
      ? `organisation-footfall-by-hour?organisationId=${
      state$.value.insightsCriteria.organisation.value
      }`
      : `client-subcategory-footfall-by-hour?customSubcategory=${encodeURIComponent(
        state$.value.insightsCriteria.subcategory.value
      )}`;

  const dayAPIEndpoint =
    state$.value.insightsCriteria.insightType === 'organisation' &&
      state$.value.insightsCriteria.organisation.value
      ? `organisation-footfall-over-time?organisationId=${
      state$.value.insightsCriteria.organisation.value
      }&timeUnit=${
      state$.value.insightsCriteria.footFallOverTimeUnit
      }`
      : `client-subcategory-footfall-over-time?customSubcategory=${encodeURIComponent(
        state$.value.insightsCriteria.subcategory.value
      )}&timeUnit=${
      state$.value.insightsCriteria.footFallOverTimeUnit
      }`




  if (state$.value.client.accountType === 'collects') {
   return state$.value.insightsCriteria.footFallOverTimeUnit === 'hour'
      ? hourAPIEndpoint
      : dayAPIEndpoint
  } else {
    return hourAPIEndpoint;
  }


}



const insightsFootfallOverTime = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_INSIGHTS_FOOTFALL_OVER_TIME),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/${
          reportsCretiria(state$)
          }${
          boundariesCriteria(state$)
          }${
          dateOptionsCriteria(state$, 'footfall')
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_INSIGHTS_FOOTFALL_OVER_TIME,
            unit: state$.value.insightsCriteria.footFallOverTimeUnit,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_INSIGHTS_FOOTFALL_OVER_TIME_ERROR,
            error,
          })
        )
      )
    )
  );

export default insightsFootfallOverTime;
